export default __webpack_public_path__ + "static/media/D2DCardImage.e8a89178.png";